import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Vienna day one",
  "description": "",
  "published": "2008-10-18T00:00:00.000Z",
  "redirect_from": ["/blog/vienna-day-one/swizec/55"],
  "categories": "travel",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today the girlfriend and yours truly arrived at Wien for a four day trip the climax of which is to be Amanda Palmer's concert at Szene ... hopefully we'll get tickets to go in as well! For some strange reason I don't really feel like talking all that much at the moment, not exactly certain why, but I'd just like to mention that mobile google maps in combination with the GPS on my blackberry are fucking fantastic!`}</p>
    <p>{`Seriously, this thing shows you where you are and how to get where you want to be, it gives to the minute accurate public transit times, what public transit to take and so on. Quite marvelous really, don't even want to think about the outstandingly absurd GPRS charge I'm going to get next month.`}</p>
    <p>{`Anyway, here's some pictures of some places we've been to today, better report to come on Tuesday ... pictures daily.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      